import confetti from "canvas-confetti";

export function fireMiniConfetti(element: HTMLElement) {
  const rect = element.getBoundingClientRect();

  const x = (rect.right + 4) / window.innerWidth;
  const y = (rect.top + rect.height / 2) / window.innerHeight;

  void confetti({
    particleCount: 75,
    angle: 0,
    spread: 50,
    startVelocity: 18,
    decay: 0.92,
    gravity: 0.1,
    ticks: 80,
    origin: { x, y },
    scalar: 0.6,
    colors: ["#4f46e5", "#06b6d4", "#10b981", "#f59e0b", "#ef4444"],
  });
}

const CELEBRATION_COLORS = [
  "#4f46e5",
  "#06b6d4",
  "#10b981",
  "#f59e0b",
  "#ef4444",
  "#8b5cf6",
  "#ec4899",
];

// A single burst spawned just above the given element's top edge that
// rains straight down through the column. Used when a pipeline Review-All
// session clears the Applied bucket.
export function fireColumnRainConfetti(element: HTMLElement) {
  const rect = element.getBoundingClientRect();
  if (rect.width <= 0 || rect.height <= 0) return;

  const x = (rect.left + rect.width / 2) / window.innerWidth;
  const y = Math.max(0, rect.top - 8) / window.innerHeight;

  void confetti({
    particleCount: 40,
    angle: 270,
    spread: 90,
    startVelocity: 10,
    gravity: 1,
    decay: 0.93,
    ticks: 220,
    origin: { x, y },
    scalar: 0.7,
    colors: CELEBRATION_COLORS,
    disableForReducedMotion: true,
  });
}

/**
 * Full-page confetti celebration — fires one of three cannons (left, right, or
 * center) at random so consecutive completions feel varied instead of
 * blasting the whole screen every time.
 */
export function fireFullPageConfetti() {
  const defaults = {
    colors: CELEBRATION_COLORS,
    disableForReducedMotion: true,
  };

  const cannons = [
    () =>
      confetti({
        ...defaults,
        particleCount: 80,
        angle: 60,
        spread: 55,
        startVelocity: 55,
        origin: { x: 0, y: 1 },
        scalar: 1,
      }),
    () =>
      confetti({
        ...defaults,
        particleCount: 80,
        angle: 120,
        spread: 55,
        startVelocity: 55,
        origin: { x: 1, y: 1 },
        scalar: 1,
      }),
    () =>
      confetti({
        ...defaults,
        particleCount: 100,
        angle: 90,
        spread: 120,
        startVelocity: 40,
        origin: { x: 0.5, y: 0.6 },
        scalar: 1.1,
        gravity: 0.8,
      }),
  ];

  void cannons[Math.floor(Math.random() * cannons.length)]();
}
